import React from 'react';
import {
  Alert,
  LoadingProgress,
  NotificationToast,
} from '@oolio-group/design-ui-react';
import { Onboarding } from '@/features/onboarding/Onboarding';
import { useOnboardingCompletion } from '@/hooks/useOnboardingCompletion';
import styles from './OnboardingScreen.module.css';

export const OnboardingScreen: React.FC = () => {
  const {
    hasPairingConflict,
    isDevicePairing,
    error,
    clearError,
    handleOnboardingCompletion,
    dismiss,
    confirm,
  } = useOnboardingCompletion();

  return (
    <>
      <Onboarding onCompleted={handleOnboardingCompletion} />

      {/* Show error notification if pairing fails */}
      <NotificationToast
        style="negative"
        message={error || ''}
        onClose={clearError}
        show={!!error}
      />

      {isDevicePairing && (
        <div className={styles.bg} aria-busy="true" aria-live="polite">
          <div className={styles.devicePairingLoading}>
            <span className={styles.devicePairingLoadingText}>
              Pairing device...
            </span>
            <LoadingProgress loading />
          </div>
        </div>
      )}

      <Alert
        id="onboarding-pairing-alert"
        show={hasPairingConflict}
        title="Device Already Paired"
        message="This device is already paired with another system. Would you like to unpair it and pair it with this system instead?"
        onDismiss={dismiss}
        onConfirm={confirm}
        style="negative"
      />
    </>
  );
};
